<template>
  <div class="col-sm-12">
    <h3>
      Teams
      <a
        v-if="canCreateGroupsAndTeams"
        :href="'/myorganisation/group/create?organisationId=' + id + '&groupType=team'"
        class="btn btn-sm btn-primary pull-right"
        style="margin-left: 20px"
        >Create Team</a
      >
    </h3>
    <table
      class="table table-hover"
      v-data-table="
        sortedTeams.length && {
          paging: false,
          searching: true,
          info: false,
          columnDefs: [{ targets: 2, orderable: false }],
          order: [[0, 'asc']],
        }
      "
    >
      <thead>
        <tr>
          <th>Name</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="team in sortedTeams" :key="team.group.id">
          <td>
            <a
              :href="'/myorganisation/group/details/' + team.group.id"
              target="_blank"
              rel="noopener noreferrer"
              data-test="team-name-link"
              >{{ team.group.name }}</a
            >
          </td>
          <td data-test="team-member-numbers">
            {{ team.members.length }} member{{ pluralEnding(team.members.length) }}
            <span v-if="countOfGroupMembersOutsideOrganisation(team)"
              >({{ countOfGroupMembersOutsideOrganisation(team) }} external)</span
            >
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { GroupAndMembersApiModel, OrganisationAndMembersApiModel } from "../../../api-models";
import TeamsOrGroups from "../../../typings/enums/teams-or-groups";

const props = defineProps<{
  id: string;
  model: OrganisationAndMembersApiModel;
  sortedTeams: GroupAndMembersApiModel[];
  canCreateGroupsAndTeams: boolean;
}>();

const emit = defineEmits(["add-groups"]);

function pluralEnding(count: number, singular = "", plural = "s"): string {
  return count === 1 ? singular : plural;
}

function countOfGroupMembersOutsideOrganisation(groupAndMembers: GroupAndMembersApiModel): number {
  return groupAndMembers?.members.filter((m) => (m.organisation?.id || null) !== props.model?.id)
    .length;
}

function addGroups(payload: TeamsOrGroups): void {
  emit("add-groups", payload);
}
</script> 